import { useState, useEffect } from "react"
import type { ThemePreset } from "../components/ThemePresetSelector"

export function useThemePreset(): ThemePreset {
  const [preset, setPreset] = useState<ThemePreset>(
    () => (document.documentElement.getAttribute("data-preset") as ThemePreset) || "custom"
  )

  useEffect(() => {
    const handler = (e: Event) => {
      setPreset((e as CustomEvent<ThemePreset>).detail)
    }
    window.addEventListener("theme-preset-change", handler)
    return () => window.removeEventListener("theme-preset-change", handler)
  }, [])

  return preset
}
